import moment from "moment-jalaali";
import { toLatinDigits, toPersianDigits } from "./numberFormat";

// Checks and representations already store Jalali dates. Do not reinterpret
// their year as Gregorian or use Date, which can shift a date across time zones.
export const formatJalaliDate = (value) => {
  if (value == null || String(value).trim() === "") return "—";
  const text = toLatinDigits(value).trim();
  const match = text.match(/^(\d{4})[-/](\d{1,2})[-/](\d{1,2})$/);
  return toPersianDigits(match
    ? `${match[1]}/${match[2].padStart(2, "0")}/${match[3].padStart(2, "0")}`
    : text);
};

// Document invoice dates are Gregorian Django DateFields.
export const formatGregorianDate = (value) => {
  if (!value) return "—";
  const date = moment(toLatinDigits(value), "YYYY-MM-DD", true);
  return date.isValid() ? toPersianDigits(date.format("jYYYY/jMM/jDD")) : "—";
};
